import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatStepperModule } from '@angular/material/stepper';
import { MatButtonModule } from '@angular/material/button';
import { MatRadioModule } from '@angular/material/radio';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDialogCustomComponent } from './mat-dialog-custom.component';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { SharedModule } from '@shared/shared.module';
import { PriceInformationModule } from '@shared/price-information/price-information.module';
import { SelectCurrencyModule } from '@shared/select-currency/select-currency.module';
import { PaymentMethodListModule } from '@shared/payment-method-list/payment-method-list.module';
import { CurrencyMoneyModule } from '@shared/currency-money/currency-money.module';
import { MatStepperCustomModule } from '@shared/mat-stepper-custom/mat-stepper-custom.module';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { ButtonHelpModule } from '@shared/button-help/button-help.module';
import { ErrorMinValuePipeModule } from '@pipes/error-min-value/error-min-value.module';
import { ErrorMaxValuePipeModule } from '@pipes/error-max-value/error-max-value.module';

@NgModule({
  declarations: [MatDialogCustomComponent],
  imports: [
    SharedModule,
    MatStepperModule,
    MatButtonModule,
    MatIconModule,
    MatProgressBarModule,
    ButtonHelpModule,
  ],
  exports: [
    MatDialogModule,
    MatDialogCustomComponent,
    MatStepperCustomModule,
    PriceInformationModule,
    SelectCurrencyModule,
    PaymentMethodListModule,
    CurrencyMoneyModule,
    MatButtonModule,
    MatIconModule,
    MatRadioModule,
    FormsModule,
    ReactiveFormsModule,
    MatInputModule,
    MatSelectModule,
    MatProgressSpinnerModule,
    ErrorMinValuePipeModule,
    ErrorMaxValuePipeModule,
  ],
})
export class MatDialogCustomModule {}
